<script lang="ts">
  import {user} from './stores/user'
  import {Route} from 'svelte5-router'
  import type {Component, Snippet} from 'svelte'

  export let path: string
  export let component: Component<any, any> | undefined = undefined
  export let children: Snippet<[any]> | undefined = undefined
</script>

{#if $user}
  {#if children}
    <Route path={path} {children} />
  {:else if component}
    <Route path={path} {component}/>
  {/if}
{/if}
